import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search, Globe, Shield, RefreshCw, Clock } from "lucide-react";
import PartnersSection from "@/components/home/PartnersSection";
import SEOHead from "@/components/seo/SEOHead";
import SchemaMarkup from "@/components/seo/SchemaMarkup";

const domainExtensions = [
  { extension: ".com", price: "999", popular: true },
  { extension: ".net", price: "1,849", popular: false },
  { extension: ".com.bd", price: "849", popular: true },
  { extension: ".edu.bd", price: "849", popular: false },
  { extension: ".org", price: "1,649", popular: false },
  { extension: ".online", price: "249", popular: false },
  { extension: ".store", price: "299", popular: false },
  { extension: ".xyz", price: "299", popular: false },
];

const features = [
  {
    icon: Globe,
    title: "Free WHOIS Privacy",
    description: "Protect your personal information from public WHOIS lookups.",
  },
  {
    icon: Shield,
    title: "Domain Protection",
    description: "Advanced security features to prevent unauthorized transfers.",
  },
  {
    icon: RefreshCw,
    title: "Easy Management",
    description: "Intuitive control panel for DNS, nameservers, and more.",
  },
  {
    icon: Clock,
    title: "Instant Activation",
    description: "Your domain is active within minutes of registration.",
  },
];

const Domain = () => {
  return (
    <Layout>
       <SEOHead
         title="Cheap Domain Registration Bangladesh | .com .com.bd Domain from ৳249"
         description="Cheap domain Bangladesh - register .com, .com.bd, .net domains at lowest prices from ৳249/year. Domain registration Bangladesh with free WHOIS privacy &amp; instant activation. Domain hosting Bangladesh by Web Host Buy BD."
         canonical="/domain"
         type="product"
         keywords="cheap domain Bangladesh, domain registration Bangladesh, domain hosting Bangladesh, Web Host Buy BD, web host bd, bdix domain, cheapest domain, best domain registrar, buy domain online, domain registrar Bangladesh"
       />
      <SchemaMarkup
        type="product"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Domain Registration", url: "/domain" },
        ]}
        products={domainExtensions.map((d) => ({
          name: `${d.extension} Domain Registration Bangladesh`,
          description: `Cheap domain Bangladesh - Register ${d.extension} domain with free WHOIS privacy and instant activation`,
          price: d.price,
        }))}
        pageName="Cheap Domain Bangladesh - Domain Registration BD"
        pageDescription="Cheap domain Bangladesh with domain registration and domain hosting. Best domain price in BD from ৳249/year."
      />
      <PageHero
        badge="Domain Registration Bangladesh"
        title="Cheap Domain Registration in Bangladesh"
        subtitle="Register your domain at lowest prices in Bangladesh. Cheap domain BD with free WHOIS privacy, instant activation, and 24/7 support."
      />

      {/* Domain Search */}
      <section className="py-16 bg-background" aria-label="Domain search">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <form
              action="https://my.webhostbuybd.com/cart.php?a=add&domain=register"
              method="POST"
            >
              <div className="flex gap-4">
                <div className="flex-1 relative">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground w-5 h-5" aria-hidden="true" />
                  <Input
                    type="text"
                    name="query"
                    placeholder="Search for your domain name..."
                    className="pl-12 h-14 text-lg rounded-xl"
                    aria-label="Search for domain name"
                    required
                  />
                </div>
                <Button type="submit" variant="gradient" size="lg" className="h-14 px-8">
                  Search
                </Button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Domain Pricing */}
      <section className="py-16 bg-muted/30" aria-labelledby="domain-pricing-heading">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 id="domain-pricing-heading" className="text-3xl font-bold text-foreground mb-4">
              Domain Pricing in Bangladesh
            </h2>
            <p className="text-muted-foreground">
              Affordable domain registration in BD with no hidden fees.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {domainExtensions.map((domain) => (
              <article
                key={domain.extension}
                className={`relative p-6 rounded-xl bg-card border ${
                  domain.popular ? "border-primary shadow-glow" : "border-border"
                } text-center card-hover flex flex-col h-full min-h-[180px]`}
              >
                {domain.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-primary text-primary-foreground text-xs font-medium">
                    Popular
                  </span>
                )}
                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-foreground mb-2">
                    {domain.extension}
                  </h3>
                  <div className="text-muted-foreground mb-4">
                    ৳{domain.price}/year
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  className="w-full mt-auto"
                  asChild
                >
                  <a href="https://my.webhostbuybd.com/cart.php?a=add&domain=register">
                    Register
                  </a>
                </Button>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-background" aria-labelledby="domain-features-heading">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 id="domain-features-heading" className="text-3xl font-bold text-foreground mb-4">
              Included with Every Domain
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature) => (
              <article
                key={feature.title}
                className="p-6 rounded-xl bg-card border border-border text-center"
              >
                <div className="feature-icon mx-auto mb-4" aria-hidden="true">
                  <feature.icon className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <PartnersSection />
    </Layout>
  );
};

export default Domain;